module.exports = __webpack_public_path__ + "static/media/felinos.ec070ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/felinos.png
// module id = 132
// module chunks = 0